import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import localeKo from '@angular/common/locales/ko';
import { DatePipe, registerLocaleData } from '@angular/common';
import { MarkdownModule } from "ngx-markdown";

import { ApiInjectables } from './shared/services/api/api.injectables';
import { AudioInjectables } from './shared/services/audio/audio.injectables';
import { BearInjectables } from './shared/services/bear/bear.injectables';
import { BoardInjectables } from "./shared/services/board/board.injectables";
import { DialectInjectables } from "./shared/services/dialect/dialect.injectables";
import { DynamicComponentInjectables } from "./shared/services/dynamic-component/dynamic-component.injectables";
import { GlobalEventInjectables } from "./shared/services/global-event/global-event.injectables";
import { GreetingInjectables } from "./shared/services/greeting/greeting.injectables";
import { HanjaInjectables } from "./shared/services/hanja/hanja.injectables";
import { HttpInterceptorInjectables } from "./shared/services/http-interceptor/http-interceptor.injectables";
import { HomonymInjectables } from "./shared/services/homonym/homonym.injectables";
import { LastIdInjectables } from "./shared/services/last-id/last-id.injectables";
import { LayoutMgrInjectables } from "./shared/services/layout-mgr/layout-mgr.injectables";
import { ListHelpInjectables } from './shared/services/list-help/list-help.injectables';
import { OptionInjectables } from './shared/services/option/option.injectables';
import { PitchInjectables } from "./shared/services/pitch/pitch.injectables";
import { ProverbInjectables } from './shared/services/proverb/proverb.injectables';
import { RecorderInjectables } from "./shared/services/recorder/recorder.injectables";
import { RedPipeInjectables } from "./shared/services/red-pipe/red-pipe.injectables";
import { ResizeInjectables } from './shared/services/resize/resize.injectables';
import { SaseungHangulInjectables } from "./shared/services/saseung-hangul/saseung-hangul.injectables";
import { Saseung3HangulInjectables } from "./shared/services/saseung3-hangul/saseung3-hangul.injectables";
import { Saseung3HanjaInjectables } from "./shared/services/saseung3-hanja/saseung3-hanja.injectables";
import { Saseung3StatsInjectables } from "./shared/services/saseung3-stats/saseung3-stats.injectables";
import { SnsInjectables } from "./shared/services/sns/sns.injectables";
import { TfSpiceInjectables } from "./shared/services/tf-service/tf-spice.injectables";
import { TotalInjectables } from "./shared/services/total/total.injectables";
import { UserInjectables } from './shared/services/user/user.injectables';
import { VideoInjectables } from './shared/services/video/video.injectables';
import { VoiceInjectables } from './shared/services/voice/voice.injectables';
import { WordInjectables } from './shared/services/word/word.injectables';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainModule } from './main/main.module';
import { WordModule } from './word/word.module';
import { DialectModule } from './dialect/dialect.module';
import { SaseungModule } from './saseung/saseung.module';
import { Saseung3Module } from './saseung3/saseung3.module';
import { ProverbModule } from './proverb/proverb.module';
import { MovieCollectModule } from './movie-collect/movie-collect.module';
import { OptionsModule } from './options/options.module';
import { BoardModule } from './board/board.module';
import { DonationModule } from './donation/donation.module';
import { ReferenceModule } from './reference/reference.module';
import { OpenSourceModule } from './open-source/open-source.module';
import { LoanwordModule } from './loanword/loanword.module';
import { ProperWordingModule } from './proper-wording/proper-wording.module';
import { ExampleModule } from './example/example.module';
import { TotalModule } from "./total/total.module";
import { CallbackModule } from "./callback/callback.module";
import { LinkModule } from "./link/link.module";
import { LegalNoticeModule } from "./legal-notice/legal-notice.module";
import { AdminMsgComponent } from './admin-msg/admin-msg.component';
import { AdminMsgModule } from "./admin-msg/admin-msg.module";


registerLocaleData(localeKo);


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MarkdownModule.forRoot(),
    AppRoutingModule,
    MainModule,
    WordModule,
    DialectModule,
    SaseungModule,
    Saseung3Module,
    ProverbModule,
    MovieCollectModule,
    OptionsModule,
    BoardModule,
    DonationModule,
    ReferenceModule,
    OpenSourceModule,
    LoanwordModule,
    ProperWordingModule,
    ExampleModule,
    TotalModule,
    CallbackModule,
    LinkModule,
    LegalNoticeModule,
    AdminMsgModule,
  ],
  providers: [
    DatePipe,
    ApiInjectables,
    AudioInjectables,
    BearInjectables,
    BoardInjectables,
    DialectInjectables,
    DynamicComponentInjectables,
    GlobalEventInjectables,
    GreetingInjectables,
    HanjaInjectables,
    HttpInterceptorInjectables,
    HomonymInjectables,
    LastIdInjectables,
    LayoutMgrInjectables,
    ListHelpInjectables,
    OptionInjectables,
    PitchInjectables,
    ProverbInjectables,
    RecorderInjectables,
    RedPipeInjectables,
    ResizeInjectables,
    SaseungHangulInjectables,
    Saseung3HangulInjectables,
    Saseung3HanjaInjectables,
    Saseung3StatsInjectables,
    SnsInjectables,
    TfSpiceInjectables,
    TotalInjectables,
    UserInjectables,
    VideoInjectables,
    VoiceInjectables,
    WordInjectables,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
